// @flow
/* eslint-disable no-use-before-define */
/* eslint-disable no-console */
import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLocation, withRouter, Link } from 'react-router-dom';
import { Input } from '../../../../basic/form/Input';
import { Checkbox } from '../../../../basic/form/Checkbox';
import { Button } from '../../../../basic/Button';
import { paths } from '../../../../../core/constants';
import { Form } from '../../../../basic/form/Form';
import { useRegistrationForm } from './useRegistrationForm';
import { ConsentCheckboxLabel } from './ConsentCheckboxLabel';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  wrapper: {
    width: '280px',
    display: 'flex',
    flexDirection: 'column',
  },
  title: { textAlign: 'center' },
  footer: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  loginLink: {
    display: 'block',
    marginTop: theme.spacing(2),
  },
  row: {
    width: '100%',
    margin: theme.spacing(1, 0),
  },
  checkboxWrapper: { margin: theme.spacing(2, 0) },
}));

const RegistrationForm = withRouter(() => {
  const query = useLocation().search;
  const classes = useStyles();
  const { onFormSubmit, trackAlreadyHaveAccountClick, validate } =
    useRegistrationForm();

  return (
    <div className={classes.root}>
      <Form onSubmit={onFormSubmit} validate={validate}>
        {({ submitting }) => {
          return (
            <div className={classes.root}>
              <div className={classes.wrapper}>
                <p className={classes.title}>
                  <span>Your account will be </span>
                  <strong>private </strong>
                  <span>and visible only to the companies you apply to.</span>
                </p>
                <Input
                  controlProps={{ className: classes.row }}
                  type="text"
                  name="name"
                  id="name"
                  autoComplete="name"
                  label="First & last name"
                  placeholder="John Doe"
                  required
                />

                <Input
                  controlProps={{ className: classes.row }}
                  type="email"
                  name="email"
                  id="email"
                  label="Email"
                  autoComplete="email"
                  placeholder="john@doe.com"
                  required
                />

                <Input
                  controlProps={{ className: classes.row }}
                  type="password"
                  name="password"
                  id="password"
                  label="Password"
                  autoComplete="password"
                  required
                />

                <Input
                  controlProps={{ className: classes.row }}
                  type="password"
                  name="repeatPassword"
                  id="repeatPassword"
                  label="Repeat password"
                  autoComplete="new-password"
                  required
                />

                <Checkbox
                  id="consentGdpr"
                  name="consentGdpr"
                  controlProps={{ className: classes.row }}
                  value="consentGdpr"
                  label={<ConsentCheckboxLabel />}
                />

                <div className={classes.footer}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={!!submitting}
                  >
                    {submitting ? 'Just a sec...' : 'Create Account'}
                  </Button>
                  <Link
                    onClick={trackAlreadyHaveAccountClick}
                    className={classes.loginLink}
                    to={{ pathname: paths.login, search: query }}
                  >
                    Have an account? Login!
                  </Link>
                </div>
              </div>
            </div>
          );
        }}
      </Form>
    </div>
  );
});

export { RegistrationForm };
